export default __webpack_public_path__ + "static/media/man-imigra-1.1da5517d.jpeg";